import React from "react";
import { observer } from "mobx-react";
import { MenuSportItemButton } from ".";
import { BaseOfferMenuStore as OfferMenuStore } from "@state/stores/offer/shared/BaseOfferMenuStore";

import SkeletonLoader from "./SkeletonLoader";

export const MainSportsList = observer(function MainSportsList(props: {
	store: OfferMenuStore;
}) {
	if (props.store.isLoading) {
		return <SkeletonLoader />;
	}

	return (
		<>
			{props.store.menu.children.map((sportMenuItem, idx) => (
				<MenuSportItemButton
					key={sportMenuItem.node.id}
					sportMenuItem={sportMenuItem}
				/>
			))}
		</>
	);
});
